import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { 
  Home, 
  Link2, 
  Users, 
  Settings,
  CreditCard
} from "lucide-react";
import { cn } from "@/lib/utils";
import MobileMenuButton from "./sidebar/MobileMenuButton";
import DesktopSidebar from "./sidebar/DesktopSidebar";
import MobileSidebar from "./sidebar/MobileSidebar";
import { NavItem } from "./sidebar/types";

interface SidebarProps {
  navItems?: NavItem[];
  className?: string;
}

const defaultNavItems: NavItem[] = [
  { name: "Dashboard", path: "/app/dashboard", icon: Home },
  { name: "Staff", path: "/app/staff", icon: Users },
  { name: "Integrations", path: "/app/integrations", icon: Link2 },
  { name: "Plans", path: "/app/plans", icon: CreditCard },
  { name: "Settings", path: "/app/settings", icon: Settings },
];

const Sidebar = ({ navItems = defaultNavItems, className }: SidebarProps) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      <MobileMenuButton isOpen={isMobileMenuOpen} onClick={toggleMobileMenu} />
      <DesktopSidebar 
        navItems={navItems} 
        isCollapsed={isCollapsed} 
        toggleSidebar={toggleSidebar} 
        className={className}
      />
      <MobileSidebar 
        navItems={navItems} 
        isOpen={isMobileMenuOpen} 
        onClose={toggleMobileMenu} 
      />
    </>
  );
};

export default Sidebar;
